export enum SlideDirection {
  NONE = 'none',
  OUT_LEFT = 'out-left',
  OUT_RIGHT = 'out-right',
  IN = 'in',
}
